import { Button, Checkbox, Col, Form, Input, Modal, Row, Select, Spin, Tag, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { CheckCircle, ChevronDown, ChevronUp, CloseIcon, Edit } from '../../assets/icons';
import BankAccountModal from '../../components/LinkBankAccount/BankAccountModal';
import { Images } from '../../config/images';
import ResetPin from '../../pages/Account/Profile/Modals/ResetPin';
import { formatePhoneNumber } from '../../utils/formatPhoneNumber';
import { getBankLogo } from '../../utils/getBankLogo';
import { getUsCurrencyFormat, getUsCurrencyFormatWithoutDecimal } from '../../utils/usCurrencyFormatter';
import FloatingLabel from '../FloatingLabel/FloatingLabel';
import PinModalWithoutButton from '../PinModalWithoutButton/PinModalWithoutButton';
import SuccessModal from '../SuccessModal/SuccessModal';

import { AGREEMENT_ACCEPTANCES } from '../../utils/policy.constants';
import ListingAgreement from '../ListingAgreement/ListingAgreement';
import PaymentDetailOption from '../PaymentDetailOption/PaymentDetailOption';

const QuickBuyInitial = (props) => {
  const { quickBuyPropertyData, quickByOptions = {}, featchData = () => {} } = props;
  const {
    loading = false,
    pin = '',
    walletsData = [],
    agreementData = '',
    totalInvestment = '',
    totalPurchase = '',
    equity = '',
    isScrolledBuy = false,
    numberOfShare = '',
    resetPin = '',
    checkbox1 = false,
    checkbox2 = false,
    daysReamaining = '',
    isTurmAndCondistion = false,
    isMaxRangeError = false,
    isMinRangeError = false,
    sharesRemainingToPurchase = 0,
    selectedPaymentMethod = {},
    isEditPayment = false,
    minButtonValue = 0,
    handleVerifyPin = () => {},
    handlePlaceOrder = () => {},
    handleForgotPin = () => {},
    handleScrollBuy = () => {},
    handleAgreeAndContinue = () => {},
    setNumberOfShare = () => {},
    setResetPin = () => {},
    setCheckbox1 = () => {},
    setCheckbox2 = () => {},
    setPin = () => {},
    setIsTurmAndCondistion = () => {},
    handleSelectPaymentMethod = () => {},
    setIsEditPayment = () => {},
    handleAddBank = () => {},
    handleUpdateBanksList = () => {},
    handleCancelBuyOrder = () => {},
    setLoading,
    isTOSModal,
    onTOSAgreementSuccess,
    onTOSModalClose,
  } = quickByOptions;
  const userProfileData = useSelector((state) => state.userData.userData);
  const cancelOrderLoading = useSelector((state) => state.initialOffering.cancelBuyOrderLoading);
  const phoneNumber = ['+1', formatePhoneNumber(userProfileData?.phoneNumber)];

  const [bankModalOpen, setBankModalOpen] = useState(false);
  const [bankOpen, setBankOpen] = useState(false);
  const [isTextSelected, setIsTextSelected] = useState(false);
  const linkText = 'My Account>Account Balances';
  const linkPath = '/account/transactions';
  const bankVerificationText = 'My Account>Payments';
  const bankVerificationPath = '/account/payment';
  const openLink = () => {
    window.location.href = linkPath;
  };
  const openPaymentsLink = () => {
    window.location.href = bankVerificationPath;
  };

  useEffect(() => {
    return () => {
      setIsEditPayment(false);
    };
  }, [selectedPaymentMethod]);
  return (
    <>
      <BankAccountModal
        bankModalOpen={bankModalOpen}
        setBankModalOpen={(value) => setBankModalOpen(value)}
        onSuccess={(value) => handleAddBank(value)}
        onClose={() => setIsEditPayment(false)}
        handleUpdateBanksList={handleUpdateBanksList}
        shouldUpdateList
      />
      {props.open === 'StepOne' && (
        <PinModalWithoutButton
          onCancel={() => {
            props.modalState();
            setPin(undefined);
          }}
          open={props.open === 'StepOne'}
          pin={pin}
          loading={loading}
          handleForgotPin={handleForgotPin}
          setPin={setPin}
          setLoading={setLoading}
          onSuccess={handleVerifyPin}
        />
      )}
      <ResetPin phoneNumber={phoneNumber || ''} mail={userProfileData?.email || ''} setOpen={resetPin} setClose={() => setResetPin(false)} />
      <Modal
        className='quickbuy buy-order ant-modal--footer-shadow ant-modal--both'
        open={props.open === 'StepTwo'}
        title={
          <div className={isScrolledBuy ? 'buy-order-header scrolled' : 'buy-order-header'}>
            <div className='header__img'>
              {quickBuyPropertyData?.images?.image1 ? (
                <LazyLoadImage
                  onError={(element) => {
                    element.target.src = Images.noPropertyFoundImage;
                  }}
                  src={quickBuyPropertyData?.images?.image1}
                  alt='house with garden'
                />
              ) : (
                <LazyLoadImage src={Images.noPropertyFoundImage} alt='the-leonardo' />
              )}
            </div>
            <div className='header__content'>
              <p className='subhead-2 text-copper mb-0'>{quickBuyPropertyData?.name || ''}</p>
              <div className='name-type text-taupe'>
                <span className='fz-14'>{`${quickBuyPropertyData?.city || ''}, ${quickBuyPropertyData?.state || ''}`}</span>
                <span className='fz-14 ml-4 mr-4 text-taupe-60'>•</span>
                <span className='fz-14'>{quickBuyPropertyData?.propertyType || ''}</span>
              </div>
              <div className='share-details mt-12'>
                <div className='block'>
                  <span className='text-taupe-80'>Shares remaining</span>
                  <span className='subhead-3'>{getUsCurrencyFormatWithoutDecimal(quickBuyPropertyData?.sharesRemaining || 0)}</span>
                </div>
                {/* Comment out for CR change to hide investor count */}
                {/* <div className='block'>
                  <span className='text-taupe-80'>Investors</span>
                  <span className='subhead-3'>{getUsCurrencyFormatWithoutDecimal(quickBuyPropertyData?.investors || 0)}</span>
                </div> */}
                <div className='block'>
                  <span className='text-taupe-80'>Share price</span>
                  <span className='subhead-3'>{`$ ${getUsCurrencyFormat(quickBuyPropertyData?.perSharePrice || 0)}`}</span>
                </div>
              </div>
            </div>
          </div>
        }
        footer={
          <>
            <Button
              type='primary'
              className='w-100 mt-8 mb-8'
              disabled={
                isMaxRangeError ||
                isMinRangeError ||
                numberOfShare === '0' ||
                !numberOfShare ||
                Number(numberOfShare) % 1 !== 0 ||
                Number(numberOfShare) <= 0 ||
                (Number(quickBuyPropertyData?.sharesRemaining) < Number(sharesRemainingToPurchase) &&
                  Number(numberOfShare) > Number(quickBuyPropertyData?.sharesRemaining))
              }
              onClick={() => props.modalState('StepThree')}
            >
              Preview order
            </Button>
          </>
        }
        width={524}
        closeIcon={<CloseIcon onClick={() => props.modalState()} />}
        centered
      >
        <div className='buy-content' onScroll={(e) => handleScrollBuy(e)}>
          <h4 className='mt-40 mb-34'>Create buy order</h4>
          <FloatingLabel label='Number of shares' inputId='shares' inputValue={numberOfShare}>
            <Form.Item
              className='mb-12'
              validateStatus={
                (isMaxRangeError ||
                  isMinRangeError ||
                  Number(numberOfShare) % 1 !== 0 ||
                  (Number(quickBuyPropertyData?.sharesRemaining) < Number(sharesRemainingToPurchase) &&
                    Number(numberOfShare) > Number(quickBuyPropertyData?.sharesRemaining))) &&
                'error'
              }
              help={
                Number(numberOfShare) % 1 !== 0
                  ? 'Decimal numbers are not allowed.'
                  : Number(quickBuyPropertyData?.sharesRemaining) < Number(sharesRemainingToPurchase) &&
                    Number(numberOfShare) > Number(quickBuyPropertyData?.sharesRemaining)
                  ? 'You have exceeded the Buy out limit.(i.e shares remaining)'
                  : isMaxRangeError
                  ? 'You have exceeded the Buy out limit.(i.e more than 9.8%)'
                  : isMinRangeError && `You have to buy minimum  ${minButtonValue?.toString()} share.`
              }
            >
              <Input
                value={numberOfShare}
                onChange={(e) => setNumberOfShare(e.target.value.replace(/[^0-9]/g, ''))}
                onSelect={(e) => {
                  window.getSelection().toString().length > 0 ? setIsTextSelected(true) : setIsTextSelected(false);
                }}
                onKeyPress={(event) => {
                  if ((Number(event.target.value) > Number(sharesRemainingToPurchase?.toFixed(0)) || !/[0-9]/.test(event.key)) && !isTextSelected) {
                    event.preventDefault();
                  }
                }}
                id='share'
              />
            </Form.Item>
          </FloatingLabel>
          <div className='mb-30 buy-tags'>
            <Tag
              className={numberOfShare?.toString() === minButtonValue?.toString() && 'ant-tag__selected'}
              onClick={() => setNumberOfShare(minButtonValue?.toString() || '0')}
            >
              {`min: ${minButtonValue?.toString() || 0}`}
            </Tag>
            <Tag
              className={
                Number(quickBuyPropertyData?.sharesRemaining) < 100 || Number(sharesRemainingToPurchase) < 100
                  ? 'ant-tag-disabled'
                  : numberOfShare?.toString() === '100' && 'ant-tag__selected'
              }
              onClick={() => {
                Number(quickBuyPropertyData?.sharesRemaining) > 100 && Number(sharesRemainingToPurchase) > 100 && setNumberOfShare('100');
              }}
            >
              most popular: 100
            </Tag>
            <Tag
              className={
                Number(quickBuyPropertyData?.sharesRemaining) < Number(sharesRemainingToPurchase)
                  ? 'ant-tag-disabled'
                  : numberOfShare?.toString() === sharesRemainingToPurchase.toString() && 'ant-tag__selected'
              }
              onClick={() =>
                Number(quickBuyPropertyData?.sharesRemaining) > Number(sharesRemainingToPurchase) &&
                setNumberOfShare(sharesRemainingToPurchase.toString() || '0')
              }
            >
              {`max (9.8%): ${sharesRemainingToPurchase || 0}`}
            </Tag>
          </div>
          <div className='mb-40 basic-info'>
            <div className='basic-info__item'>
              <span className='basic-info__item__name'>Total Investment (USD)</span>
              <span className='basic-info__item__value fw-600'>{`$ ${getUsCurrencyFormat(totalInvestment)}`}</span>
            </div>
            <div className='basic-info__item'>
              <span className='basic-info__item__name'>Platform Fee</span>
              <span className='basic-info__item__value'>$2.50</span>
            </div>
            <div className='basic-info__item'>
              <span className='basic-info__item__name'>Total Purchase (USD)</span>
              <span className='basic-info__item__value fw-600'>{`$ ${getUsCurrencyFormat(totalPurchase)}`}</span>
            </div>
            <div className='basic-info__item'>
              <Tooltip
                title={`The equity you own in a property is calculated by dividing the shares you own by the total number of shares available. The maximum equity percentage you can have in a property is 9.8% due to SEC regulations.`}
              >
                <span className='basic-info__item__name underline cursor-pointer'>Equity</span>
              </Tooltip>
              <span className='basic-info__item__value'>{`${equity || ''} %`}</span>
            </div>
            <div className='basic-info__item'>
              <Tooltip
                title={`The duration of an order for an initial offering will last until the property’s funding period concludes. The funding period may conclude before the 90 day allotment is over if the property reaches its goal early. At that time your order will be executed. If the property fails to reach its goal in this period, your funds will be returned to you.`}
              >
                <span className='basic-info__item__name underline cursor-pointer'>Duration</span>
              </Tooltip>
              <span className='basic-info__item__value'>{`${daysReamaining || ''} days remaining`}</span>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        className='quickbuy review-buy-order ant-modal--footer-shadow ant-modal--footer'
        open={props.open === 'StepThree'}
        width={524}
        closeIcon={
          <CloseIcon
            onClick={() => {
              props.modalState();
              setIsEditPayment(false);
            }}
          />
        }
        footer={
          <>
            <Row gutter={16} className='mt-8 mb-8'>
              <Col span={12}>
                <Button className='w-100' onClick={() => props.modalState('StepTwo')}>
                  Back
                </Button>
              </Col>
              <Col span={12}>
                <Button
                  disabled={!isTurmAndCondistion || selectedPaymentMethod?.bankVerificationStatus !== 'Verified'}
                  loading={loading}
                  type='primary'
                  className='w-100'
                  onClick={() => handlePlaceOrder()}
                >
                  Place order
                </Button>
              </Col>
            </Row>
          </>
        }
        centered
      >
        <h4 className='text-center mb-24'>Review buy order</h4>
        <p className='fw-600'>Investment details</p>
        <div className='d-flex flex-column g-16 fz-14 mb-16'>
          <div className='d-flex align-items-center justify-content-space-between'>
            <span className='text-taupe-80'>Shares</span>
            <span>{numberOfShare || 0}</span>
          </div>
          <div className=' d-flex align-items-center justify-content-space-between'>
            <span className='text-taupe-80'>Price per Share</span>
            <span>{`$${getUsCurrencyFormat(quickBuyPropertyData?.perSharePrice || 0)}`}</span>
          </div>
          <div className='d-flex align-items-center justify-content-space-between'>
            <span className='text-taupe-80'>Total Investment (USD)</span>
            <span className='fw-600'>{`$${getUsCurrencyFormat(totalInvestment || 0)}`}</span>
          </div>
          <div className=' d-flex align-items-center justify-content-space-between'>
            <span className='text-taupe-80'>Platform Fee</span>
            <span>{`$${getUsCurrencyFormat(2.5)}`}</span>
          </div>
        </div>
        <hr />
        <div className='d-flex flex-column g-16 fz-14 mt-16'>
          <div className='d-flex align-items-center justify-content-space-between'>
            <span className='text-taupe-80'>Total Purchase (USD)</span>
            <span className='fw-600'>{`$${getUsCurrencyFormat(totalPurchase || 0)}`}</span>
          </div>
          <div className='d-flex align-items-center justify-content-space-between'>
            <Tooltip title='The equity you own in a property is calculated by dividing the shares you own by the total number of shares available. The maximum equity percentage you can have in a property is 9.8% due to SEC regulations.'>
              <span className='text-taupe-80 underline'>Equity</span>
            </Tooltip>
            <span>{`${equity || ''}%`}</span>
          </div>
          <div className='d-flex align-items-center justify-content-space-between'>
            <Tooltip title='The duration of an order for an initial offering will last until the property’s funding period concludes. The funding period may conclude before the 90 day allotment is over if the property reaches its goal early. At that time your order will be executed. If the property fails to reach its goal in this period, your funds will be returned to you.'>
              <span className='text-taupe-80 underline'>Duration</span>
            </Tooltip>
            <span>{`${daysReamaining || ''} days remaining`}</span>
          </div>
        </div>
        <p className='fw-600 mt-32'>Payment details</p>
        {!!isEditPayment ? (
          <>
            <FloatingLabel label='Payment method' inputId='bankSelect' inputValue={selectedPaymentMethod.id}>
              <div id='bank-anchor' />
              <Form.Item className='mb-0' name='bankSelect'>
                <Select
                  id='bankSelect'
                  onChange={(value) => {
                    const banksList = walletsData?.filter((item) => item?.sourceType !== 'Wallet');
                    if (value !== -1) {
                      handleSelectPaymentMethod(value);
                    } else {
                      setBankModalOpen(true);
                    }
                  }}
                  disabled={loading}
                  defaultValue={selectedPaymentMethod.id}
                  value={selectedPaymentMethod.id}
                  menuItemSelectedIcon={<CheckCircle verticalAlign='-8px' />}
                  getPopupContainer={() => document.getElementById('bank-anchor')}
                  onDropdownVisibleChange={() => setBankOpen(!bankOpen)}
                  suffixIcon={bankOpen ? <ChevronUp color='#1A1519' /> : <ChevronDown color='#1A1519' />}
                >
                  {walletsData?.map((item) => (
                    <Select.Option
                      key={item?.id}
                      value={item.id}
                      disabled={item?.bankVerificationStatus !== 'Verified' && item?.sourceType !== 'add new'}
                    >
                      <PaymentDetailOption item={item} totalInvestment={totalInvestment} />
                    </Select.Option>
                  ))}
                </Select>
                {selectedPaymentMethod?.sourceType === 'Wallet' && totalInvestment > selectedPaymentMethod?.balance && (
                  <div className='pt-10 error-text'>
                    <span style={{ cursor: 'pointer' }} onClick={openLink}>
                      Please go to {<a href={linkPath}>{linkText}</a>} to transfer funds into your account.
                    </span>
                  </div>
                )}
                {selectedPaymentMethod?.bankVerificationStatus !== 'Verified' && (
                  <div className='pt-10 error-text'>
                    <span style={{ cursor: 'pointer' }} onClick={openPaymentsLink}>
                      Selected Bank has not been verified yet to initiate the transaction. Please go to{' '}
                      {<a href={bankVerificationPath}>{bankVerificationText}</a>} to verify your bank.
                    </span>
                  </div>
                )}
              </Form.Item>
            </FloatingLabel>
          </>
        ) : (
          <>
            <div className='d-flex g-8 align-items-center'>
              {getBankLogo(selectedPaymentMethod?.brandName)}
              <span className='fz-16'>
                {selectedPaymentMethod?.brandName === 'DWOLLA' ? 'Dwolla Wallet' : selectedPaymentMethod?.brandName || ''}
              </span>
              {selectedPaymentMethod?.sourceType !== 'Wallet' && (
                <span className='text-taupe-80 fz-16'>{`*** ${selectedPaymentMethod?.lastFourDigit || ''}`}</span>
              )}
              {selectedPaymentMethod?.sourceType === 'Wallet' &&
              selectedPaymentMethod?.balance !== undefined &&
              selectedPaymentMethod?.balance !== null ? (
                totalInvestment > selectedPaymentMethod?.balance ? (
                  <span className='text-taupe-80 fz-16 error-text'>Insufficient balance</span>
                ) : (
                  <span className='text-taupe-80 fz-16'>{`$${Number(selectedPaymentMethod?.balance)
                    .toFixed(2)
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}</span>
                )
              ) : null}

              <Edit className='ml-auto cursor-pointer' size={20} color='#726460' onClick={() => setIsEditPayment(true)} />
            </div>
            {selectedPaymentMethod?.sourceType === 'Wallet' && totalInvestment > selectedPaymentMethod?.balance && (
              <div className='pt-10 error-text'>
                <span style={{ cursor: 'pointer' }} onClick={openLink}>
                  Please go to {<a href={linkPath}>{linkText}</a>} to transfer funds into your account.
                </span>
              </div>
            )}
            {selectedPaymentMethod?.bankVerificationStatus !== 'Verified' && (
              <div className='pt-10 error-text'>
                <span style={{ cursor: 'pointer' }} onClick={openPaymentsLink}>
                  Selected Bank has not been verified yet to initiate the transaction. Please go to{' '}
                  {<a href={bankVerificationPath}>{bankVerificationText}</a>} to verify your bank.
                </span>
              </div>
            )}
          </>
        )}
        <div className='d-flex mt-48'>
          <Checkbox
            disabled={loading}
            checked={isTurmAndCondistion}
            onChange={(value) => setIsTurmAndCondistion(value.target.checked)}
            className='mr-16'
          />
          <span className='cursor-pointer fz-14'>
            <span onClick={() => setIsTurmAndCondistion(!isTurmAndCondistion)}>I have read and accept the </span>
            <Link to={{ pathname: '/legal', hash: 'Terms of use' }} className='underline' target='_blank'>
              Terms of Use
            </Link>
            <span onClick={() => setIsTurmAndCondistion(!isTurmAndCondistion)}>, the </span>
            <Link to={{ pathname: '/legal', hash: 'Other disclosure here' }} className='underline' target='_blank'>
              Regulation A Investment Disclosure
            </Link>
            <span onClick={() => setIsTurmAndCondistion(!isTurmAndCondistion)}>, and </span>
            <Link to={{ pathname: '/legal', hash: 'Privacy Policy' }} className='underline' target='_blank'>
              Privacy Policy
            </Link>
            .
          </span>
        </div>
      </Modal>

      <Modal
        className='quickbuy agreement-modal ant-modal--footer-shadow ant-modal--footer'
        open={props.open === 'StepFour'}
        width={920}
        destroyOnClose={true}
        closeIcon={
          <CloseIcon
            disabled={loading}
            onClick={async () => {
              !loading && (await handleCancelBuyOrder());
              props?.modalState();
            }}
          />
        }
        footer={
          <Button loading={loading} type='primary' className='w-100' disabled={!checkbox1 || !checkbox2} onClick={() => handleAgreeAndContinue()}>
            Agree to terms
          </Button>
        }
        centered
      >
        <Spin spinning={cancelOrderLoading}>
          <div className='agreement-content fz-14'>
            <div dangerouslySetInnerHTML={{ __html: agreementData }} />
            <div className='checks mb-24'>
              <Checkbox className='ml-8' checked={checkbox1} onChange={() => setCheckbox1(!checkbox1)} disabled={loading}>{`I attest that I am ${
                userProfileData?.firstName || ''
              } ${userProfileData?.lastName || ''} and I understand that the signature herein is a legal representation of my own.`}</Checkbox>
              <Checkbox disabled={loading} checked={checkbox2} onChange={() => setCheckbox2(!checkbox2)}>
                {AGREEMENT_ACCEPTANCES.AGREE_SUBSCRIPTION_AGREEMENT}
              </Checkbox>
            </div>
          </div>
        </Spin>
      </Modal>

      <SuccessModal
        title='You’re an investor!'
        description={
          <>
            {`You have successfully purchased ${numberOfShare || 0} share(s) ($${getUsCurrencyFormat(
              quickBuyPropertyData?.perSharePrice || 0
            )} each) of ${quickBuyPropertyData?.name || ''}. You may track this investment in your`}
            <Link className='text-copper' to='/portfolio'>
              {' '}
              Portfolio.
            </Link>
          </>
        }
        setOpen={props.open === 'success'}
        setClose={() => {
          featchData();
          props.modalState();
        }}
        setDone={() => {
          props.modalState();
          featchData();
        }}
      />

      {isTOSModal && <ListingAgreement isOpen={isTOSModal} onClose={onTOSModalClose} onAgreementAccept={onTOSAgreementSuccess} />}
    </>
  );
};

export default QuickBuyInitial;
